/**
 * Dropdown selector for franchises.
 */

import { getUserProfileV3 } from '@/utils/api';
import { useData } from '../../hooks/useData';

import DropdownFull from '../dropdowns/DropdownFull';
import { useState } from 'react';

export default function DropdownFranchise(): JSX.Element {
  const { userFranchises, selectedFranchise, handleFranchiseChange, setLoadingProfile, loadingProfile } = useData();
  const [isLoading, setIsLoading] = useState(false);

  if (selectedFranchise === null) {
    return <></>;
  }

  async function bootstrapFranchiseChange(franchiseId: string): Promise<void> {
    setIsLoading(true);
    try {
      setLoadingProfile(true);  
      const profile = await getUserProfileV3(franchiseId);
      handleFranchiseChange(profile);
      setLoadingProfile(false);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <DropdownFull
      options={userFranchises.map((franchise) => ({
        id: franchise.id,
        value: franchise.displayName,
      }))}
      selected={{
        id: selectedFranchise.id,
        value: selectedFranchise.displayName,
      }}
      handleChange={bootstrapFranchiseChange}
      isLoading= {isLoading}
      dataCy="dropdown-franchise"
    />
  );
}
